export const watchRecentlyPlayed = {
  initial: 'init',
  states: {
    init: {
      on: {
        UPDATE_RECENTLY_PLAYED: {
          target: 'updateRecentlyPlayed',
        },
        UPDATE_RECENTLY_PLAYED_AFTER_DELAY: {
          target: 'updateRecentlyPlayedAfterDelay',
        },
        CLEAR_RECENTLY_PLAYED: {
          target: 'clearRecentlyPlayed',
        },
      },
    },
    updateRecentlyPlayedAfterDelay: {
      invoke: {
        src: 'watchRecentlyPlayedTimer',
      },
      on: {
        RECENTLY_PLAYED_TO_UPDATE: {
          target: 'updateRecentlyPlayed',
        },
      },
    },
    updateRecentlyPlayed: {
      invoke: {
        src: 'fetchRecentlyPlayedGames',
        onDone: [
          {
            target: 'init',
            actions: ['initAuthTokenRefresh', 'updateRetryStatus'],
            cond: 'isResponseInvalid_InternalAuthTokenVariant',
          },
          {
            target: 'init',
            actions: [
              'updateRecentlyPlayedGames',
              'rp_rerender',
              'getRecentlyPlayedJackpotV2',
            ],
          },
        ],
      },
    },
    clearRecentlyPlayed: {
      always: {
        target: 'init',
        actions: ['clearRecentlyPlayedGames', 'rp_rerender'],
      },
    },
  },
};
